import { L2OrderbookActionTypes } from 'actionTypes/l2Orderbook';
import createAction from 'helpers/createAction';

export const l2snapshot = createAction(L2OrderbookActionTypes.SNAPSHOT);
export const l2SnapshotError = createAction(L2OrderbookActionTypes.ERROR);
export const l2PriceClubbingUpdate = createAction(L2OrderbookActionTypes.UPDATE);
export const l2PriceClubbingReset = createAction(L2OrderbookActionTypes.RESET);
export const l2EmptySellOrders = createAction(L2OrderbookActionTypes.EMPTY_SELL_ORDERS);
